export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "success_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We will email you once the rewards have been approved!"])}
    }
  })
}
